import { render, staticRenderFns } from "./bao-cao-kenh.vue?vue&type=template&id=31c17815"
import script from "./bao-cao-kenh.vue?vue&type=script&lang=js"
export * from "./bao-cao-kenh.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports